import { ExtraCoverageKeys } from "@covertree/new-business-graphql";
import { ExtraCoverageAccessor } from "./extraCoverages/extraCoverageAccessor";

const isEnumValue = <T extends object>(
  value: unknown,
  enumType: T
): value is T[keyof T] => {
  return Object.values(enumType).includes(value as T[keyof T]);
};

const getEnumValues = <T extends object>(enumObj: T): T[keyof T][] =>
  Object.values(enumObj) as T[keyof T][];

const extraCoverageKeyToAccessorMap: Record<
  ExtraCoverageKeys,
  ExtraCoverageAccessor
> = {
  golfCarts: ExtraCoverageAccessor.GolfCartDamageAndLiabilityCoverage,
  debrisRemoval: ExtraCoverageAccessor.DebrisRemoval,
  earthquake: ExtraCoverageAccessor.EarthquakeCoverage,
  equipmentBreakdown: ExtraCoverageAccessor.EquipmentBreakdown,
  lossAssessment: ExtraCoverageAccessor.LossAssessment,
  residenceBurglary: ExtraCoverageAccessor.ResidenceBurglary,
  secondaryResidenceLiability:
    ExtraCoverageAccessor.SecondaryResidenceLiability,
  scheduledPersonalProperty: ExtraCoverageAccessor.ValuableItemProtection,
  waterBackupAndSumpOverflow: ExtraCoverageAccessor.WaterBackupCoverage,
  enhancedCoverage: ExtraCoverageAccessor.EnhancedCoverage,
  tripCollision: ExtraCoverageAccessor.TripCollisionCoverage,
  vacationRental: ExtraCoverageAccessor.VacationRentalCoverage,
  mineSubsidence: ExtraCoverageAccessor.MineSubsidence,
  mineSubsidenceScheduled: ExtraCoverageAccessor.MineSubsidenceScheduled,
  incidentalFarming: ExtraCoverageAccessor.IncidentalFarming,
  identityFraud: ExtraCoverageAccessor.IdentityFraudExpense,
  sinkhole: ExtraCoverageAccessor.SinkholeCoverage,
  buildersRisk: ExtraCoverageAccessor.BuildersRisk,
  vandalismOrMaliciousMischief:
    ExtraCoverageAccessor.VandalismOrMaliciousMischief,
  windstormOrHailExclusion: ExtraCoverageAccessor.WindstormOrHailExclusion,
  fortifiedRoofUpgrade: ExtraCoverageAccessor.FortifiedRoofUpgrade,
};

export { isEnumValue, getEnumValues, extraCoverageKeyToAccessorMap };
